module.exports = __webpack_public_path__ + "tether-buyBlue.svg?b6a6e36d87736398650ea16022857b16";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/tether-buyBlue.svg
// module id = 836
// module chunks = 2